// @ts-nocheck
// datatable related plugins
import { yupResolver } from "@hookform/resolvers/yup";
import ConfirmModal from "components/shared-components/ConfirmModal";
import {
  MODE_INVOICE_ACTION,
  TYPE_ACTION_WORKFLOW,
} from "constants/IssueInvoiceConstant";
import { generateSelectField } from "helpers/form_helper_old";
import jwt_decode from "jwt-decode";
import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { MetaTags } from "react-meta-tags";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router";
import { useToasts } from "react-toast-notifications";
import {
  Button,
  ButtonDropdown,
  Card,
  CardBody,
  Col,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Row,
} from "reactstrap";
import {
  actionWorkflowIssueInvoice,
  createIssueInvoice,
  createListProductInvoice,
  listInvoiceSymbol,
  resetActionWorkflowIssueInvoice,
  resetReplaceIssueInvoice,
} from "store/actions";
import {
  AUTH_TOKEN,
  ROLE_EINVOICE_CUA_HANG,
  ROLE_EINVOICE_KE_TOAN,
} from "store/auth/login/actionTypes";
import {
  ACTION_WORKFLOW_ISSUE_INVOICE_FAIL,
  ACTION_WORKFLOW_ISSUE_INVOICE_SUCCESS,
  ISSUE_INVOICE_CREATE_FAIL,
  ISSUE_INVOICE_CREATE_SUCCESS,
  REPLACE_ISSUE_INVOICE_FAIL,
  REPLACE_ISSUE_INVOICE_SUCCESS,
} from "store/issue-invoice/actionTypes";
import * as yup from "yup";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import DetailInvoice from "./DetailInvoice";
import ConfirmActionInvoiceTT32 from "./modal/ConfirmActionInvoiceTT32";
import {
  getTypeWorkflowMessage,
  issueInvoiceModeList,
  KHHDON_LAST,
  KHMSHDON,
} from "./utils";

const CreateInvoice = props => {
  const [listTypeHD, setListTypeHD] = useState([]);

  // isOpenAction32Modal
  const [isOpenAction32Modal, setIsOpenAction32Modal] = useState(false);
  const toggleOpenAction32Modal = () =>
    setIsOpenAction32Modal(!isOpenAction32Modal);

  // modalConfirmAction (Replace or Adjust invoice)
  const [dataConfirmAction, setDataConfirmAction] = useState(null);
  const [modalConfirmAction, setModalConfirmAction] = useState(false);
  const toggleConfirmActionModal = () =>
    setModalConfirmAction(!modalConfirmAction);

  const dispatch = useDispatch();

  const invoiceSymbol = useSelector(state => state.invoiceSymbol);
  const {
    errorList: errorInvoiceSymbolList,
    list: invoiceSymbolList,
    loadingList,
  } = invoiceSymbol;

  const Dashboard = useSelector(state => state.Dashboard);
  const { finalBuInfo } = Dashboard;

  // store reducer
  const issueInvoice = useSelector(state => state.issueInvoice);
  const { type, workflowInvoice, create, currentTime } = issueInvoice;

  const history = useHistory();
  const [detailModal, setDetailModal] = useState(false);

  const [isSelectType, setIsSelectType] = useState(false);

  const [isRoleStore, setIsRoleStore] = useState(false);
  const [isRoleAccountant, setIsRoleAccountant] = useState(false);

  useEffect(() => {
    switch (type) {
      case ISSUE_INVOICE_CREATE_SUCCESS:
        if (dataInvoiceTemp) {
          //GỬi duyệt hóa đơn
          toggleWorkflowModal();
          dispatch(
            actionWorkflowIssueInvoice(
              create.id,
              dataWorkflow.typeWorkFlow,
              null
            )
          );
        } else {
          // Tạo hóa đơn
          history.push("/invoice/new");
        }
        break;
      case ISSUE_INVOICE_CREATE_FAIL:
        break;
      case ACTION_WORKFLOW_ISSUE_INVOICE_SUCCESS: {
        let mess =
          getTypeWorkflowMessage(workflowInvoice.typeWorkflow) + " thành công";
        addToast(mess, {
          appearance: "success",
          autoDismiss: true,
        });
        toggleWorkflowModal();
        history.push("/invoice/new");
        dispatch(resetActionWorkflowIssueInvoice());
        break;
      }
      case ACTION_WORKFLOW_ISSUE_INVOICE_FAIL:
        let mess =
          getTypeWorkflowMessage(workflowInvoice.typeWorkFlow) + " thất bại";
        addToast(mess, {
          appearance: "error",
          autoDismiss: true,
        });
        dispatch(resetActionWorkflowIssueInvoice());
        break;
      case REPLACE_ISSUE_INVOICE_SUCCESS:
        addToast(`Lập hóa đơn ${dataConfirmAction.infoTT32.text} thành công`, {
          appearance: "success",
          autoDismiss: true,
        });
        setDataConfirmAction(null);
        history.push("/invoice/new");
        dispatch(resetReplaceIssueInvoice());
        break;
      case REPLACE_ISSUE_INVOICE_FAIL:
        addToast(`Lập hóa đơn ${dataConfirmAction.infoTT32.text} thất bại`, {
          appearance: "error",
          autoDismiss: true,
        });
        setDataConfirmAction(null);
        dispatch(resetReplaceIssueInvoice());
        break;
    }
  }, [type]);

  useEffect(() => {
    if (invoiceSymbolList?.items && invoiceSymbolList?.items.length > 0) {
      const data = invoiceSymbolList?.items[0];
      if (getValues("typeHD")) {
        const label =
          getValues("typeHD").ttchung_khmshdon +
          getValues("typeHD").khhdonDefault +
          data.khhdon;
        const value = getValues("typeHD").khhdonDefault + data.khhdon;
        setValue(
          "khhdon",
          {
            value,
            label,
          },
          {
            shouldValidate: true,
          }
        );
      }
    } else {
      setValue("khhdon", null);
    }
  }, [invoiceSymbolList]);

  useEffect(() => {
    setIsSelectType(false);
    setValue("typeHD", {
      value: "",
      label: "",
    });
    setValue("khhdon", null);
    let listTypeHD = [];
    let curYear = currentTime?.data?.year.toString();
    curYear = curYear?.substr(curYear?.length - 2);
    if (finalBuInfo) {
      if (finalBuInfo?.hdgtgt === 1) {
        listTypeHD.push({
          value: `PAGE_VAT_INVOICE_${
            finalBuInfo?.invoice_type === 1 ? "HAVE_CODE" : "NONE_CODE"
          }`,
          khhdonDefault: `${
            finalBuInfo?.invoice_type === 1 ? "C" : "K"
          }${curYear}${KHHDON_LAST.SALE}`,
          mode: issueInvoiceModeList.CREATE_VAT_INVOICE_DETAIL,
          ttchung_khmshdon: KHMSHDON.VAT,
          label: `HÓA ĐƠN ĐIỆN TỬ GIÁ TRỊ GIA TĂNG ${
            finalBuInfo?.invoice_type === 1 ? "(CÓ MÃ)" : "(KHÔNG MÃ)"
          }`,
        });
      }
      if (finalBuInfo?.hdbhang === 1) {
        listTypeHD.push({
          value: `PAGE_SALE_INVOICE_${
            finalBuInfo?.invoice_type === 1 ? "HAVE_CODE" : "NONE_CODE"
          }`,
          khhdonDefault: `${
            finalBuInfo?.invoice_type === 1 ? "C" : "K"
          }${curYear}${KHHDON_LAST.SALE}`,
          mode: issueInvoiceModeList.CREATE_SALE_INVOICE_DETAIL,
          ttchung_khmshdon: KHMSHDON.SALE,
          label: `HÓA ĐƠN ĐIỆN TỬ BÁN HÀNG ${
            finalBuInfo?.invoice_type === 1 ? "(CÓ MÃ)" : "(KHÔNG MÃ)"
          }`,
        });
      }
    }
    setListTypeHD(listTypeHD);
  }, [finalBuInfo]);

  // Action Dispatch
  useEffect(() => {
    const info = jwt_decode(localStorage.getItem(AUTH_TOKEN));
    const roleUser = info["auth"];
    if (roleUser) {
      const listRole = info["auth"].split(",");
      setIsRoleStore(
        listRole.findIndex(item => item === ROLE_EINVOICE_CUA_HANG) !== -1
          ? true
          : false
      );
      setIsRoleAccountant(
        listRole.findIndex(item => item === ROLE_EINVOICE_KE_TOAN) !== -1
          ? true
          : false
      );
    }
  }, []);

  const actionReplaceOrAdjustInvoice = data => {
    const finalDataConfirm = {
      ...data,
      ...dataConfirmAction,
      mode: MODE_INVOICE_ACTION.REPLACE, // Lun hiểu ở Mức thay thế vì k có hóa đơn cha để điều chỉnh
      typeAdjust: data.infoTT32.typeAdjust,
    };
    setDataConfirmAction(finalDataConfirm);
    toggleDetailModal();
  };

  const { addToast } = useToasts();

  const { t, i18n } = useTranslation(["summaryInvoiceData"]);

  const schema = yup.object().shape({
    typeHD: yup.object().required("Vui lòng  chọn loại hóa đơn"),
    khhdon: yup.object().required("Vui lòng  chọn ký hiệu hóa đơn").nullable(),
  });

  const {
    handleSubmit,
    reset,
    formState: { errors, touchedFields, isSubmitting },
    control,
    setValue,
    getValues,
    setError,
    register,
    unregister,
    trigger,
    watch,
    setFocus,
  } = useForm({
    resolver: yupResolver(schema),
    mode: "all",
    reValidateMode: "onChange",
    defaultValues: {
      typeHD: undefined,
      khhdon: undefined,
    },
  });

  // Workflow modal
  const [modalWorkflow, setModalWorkflow] = useState(false);
  const toggleWorkflowModal = () => setModalWorkflow(!modalWorkflow);
  const [dataWorkflow, setDataWorkflow] = useState({
    id: null,
    typeWorkFlow: null,
    titleModal: null,
    bodyModal: null,
  });

  // finalData: null,
  // typeAnother: null,
  // listProduct: [],
  const [dataInvoiceTemp, setDataInvoiceTemp] = useState(null);

  const [btnShowFooter, setBtnShowFooter] = useState({
    btnRelease: {
      isShow: false,
      onClick: null,
      toggleModal: null,
    },
    btnSubmit: {
      isShow: false,
      onClick: null,
      toggleModal: null,
    },
  });

  const onSubmit = values => {
    setDataConfirmAction(null);
    toggleDetailModal();
    generateButtonWhenCreate();
  };

  const onSubmitActionTT32 = () => {
    setBtnShowFooter({
      btnRelease: {
        isShow: false,
        onClick: null,
      },
      btnSubmit: {
        isShow: false,
        onClick: null,
      },
    });
    toggleConfirmActionModal();
  };

  const generateButtonWhenCreate = () => {
    setBtnShowFooter({
      btnRelease: {
        isShow: finalBuInfo?.need_approve === 0,
        onClick: null,
      },
      btnSubmit: {
        isShow: finalBuInfo?.need_approve === 1 && isRoleStore,
        onClick: null,
        toggleModal: () => {
          setDataWorkflow({
            typeWorkFlow: TYPE_ACTION_WORKFLOW.SUBMIT,
            titleModal: "Xác nhận gửi duyệt hóa đơn",
            bodyModal: "Hệ thống sẽ gửi duyệt hóa đơn này",
          });
          toggleWorkflowModal();
        },
      },
    });
  };

  const toggleDetailModal = (modeSet = "") => {
    setDetailModal(!detailModal);
  };

  return (
    <React.Fragment>
      {/* WORKFLOW modal */}
      <ConfirmModal
        isOpen={modalWorkflow}
        titleHeader={dataWorkflow.titleModal}
        titleBody={dataWorkflow.bodyModal}
        isDisableButton={workflowInvoice.loading}
        isHaveNote={dataWorkflow.typeWorkFlow === TYPE_ACTION_WORKFLOW.REJECT}
        onConfirm={note => {
          dispatch(createListProductInvoice(dataInvoiceTemp.listProduct));
          dispatch(
            createIssueInvoice(
              dataInvoiceTemp.finalData,
              dataInvoiceTemp.typeAnother
            )
          );
        }}
        textBtnConfirm={"Xác nhận"}
        textBtnCancel={"Đóng"}
        toggle={toggleWorkflowModal}
      />
      <div className="page-content">
        <MetaTags>
          <title>Lập hóa đơn</title>
        </MetaTags>
        <div className="container-fluid">
          <ConfirmActionInvoiceTT32
            confirmActionData={dataConfirmAction}
            isOpen={modalConfirmAction}
            toggle={toggleConfirmActionModal}
            actionReplaceOrAdjustInvoice={actionReplaceOrAdjustInvoice}
          />
          <Breadcrumbs title="" breadcrumbItem={"Lập hóa đơn"} />
          <Card>
            <CardBody style={{ minHeight: "450px" }}>
              <Row className="row-cols-1 row-cols-md-4 ">
                {/* Loại Hóa Đơn */}
                <Col style={{}}>
                  {generateSelectField(
                    "Loại Hóa Đơn",
                    true,
                    errors,
                    "typeHD",
                    "Vui lòng chọn",
                    false,
                    control,
                    listTypeHD,
                    "auto",
                    () => {
                      setIsSelectType(true);
                      const buTenant = localStorage.getItem("BU_STORE_HEADER");
                      // Get list ký hiệu hóa đơn ( 2 ký tự cuối)
                      invoiceSymbolList.params.page = -1;
                      invoiceSymbolList.params.sort = "name";
                      invoiceSymbolList.params.columnFilter = {
                        "filter[record_status]": "O",
                        "filter[bu_code]": buTenant,
                        "filter[khmhdon]":
                          getValues("typeHD") &&
                          getValues("typeHD").ttchung_khmshdon,
                      };
                      invoiceSymbolList.params.fields =
                        "id,khmhdon,khhdon,bu_code,record_status,tenant_code,";
                      dispatch(listInvoiceSymbol(invoiceSymbolList.params));
                    },
                    false
                  )}
                  {listTypeHD.length > 0 ? (
                    <span
                      style={{ fontStyle: "italic" }}
                      className="text-primary font-size-15 mt-2"
                    >
                      *Chọn loại hóa đơn và ký hiệu hóa đơn muốn lập
                    </span>
                  ) : (
                    <span
                      style={{ fontStyle: "italic" }}
                      className="text-danger font-size-15 mt-2"
                    >
                      *Chưa được phép lập hóa đơn. Vui lòng tạo tờ khai đăng ký
                      sử dụng hóa đơn
                    </span>
                  )}
                </Col>
                {/* Ký hiệu hóa đơn */}
                <Col style={{ width: "200px" }}>
                  {generateSelectField(
                    "Ký hiệu hóa đơn",
                    true,
                    errors,
                    "khhdon",
                    "Vui lòng chọn",
                    false,
                    control,
                    getValues("typeHD") && getValues("typeHD").ttchung_khmshdon
                      ? invoiceSymbolList?.items.map(item => {
                          const label =
                            getValues("typeHD").ttchung_khmshdon +
                            getValues("typeHD").khhdonDefault +
                            item.khhdon;
                          const value =
                            getValues("typeHD").khhdonDefault + item.khhdon;
                          return {
                            value: value,
                            label: label,
                          };
                        })
                      : [],
                    "auto",
                    () => {},
                    false
                  )}
                </Col>
                <Col style={{ marginTop: "28px", width: "171px" }}>
                  <Button
                    type="button"
                    color="primary"
                    className="me-2 btn-label"
                    disabled={loadingList || !isSelectType}
                    onClick={() => {
                      handleSubmit(onSubmit)();
                    }}
                  >
                    <i className="bx bx-receipt label-icon" />
                    Lập hóa đơn
                  </Button>
                </Col>
                {/* {isRoleAccountant && ( */}
                <Col style={{ marginTop: "28px" }}>
                  <ButtonDropdown
                    className="me-2"
                    isOpen={isOpenAction32Modal}
                    disabled={loadingList || !isSelectType}
                    toggle={toggleOpenAction32Modal}
                  >
                    <DropdownToggle
                      className="btn-label"
                      caret
                      color="info"
                      outline
                    >
                      <i className="bx bx-message-square-check label-icon" />
                      Nghiệp vụ với hóa đơn TT32
                      <i
                        style={{ marginLeft: "5px" }}
                        className="mdi mdi-chevron-down"
                      />
                    </DropdownToggle>
                    <DropdownMenu
                      style={{ zIndex: 3, border: " 1px solid #808080d4" }}
                    >
                      <div style={{ color: "white" }}>
                        <DropdownItem
                          style={{ position: "relative" }}
                          className="d-flex gap-1 align-items-center"
                          onClick={() => {
                            setDataConfirmAction({
                              mode: MODE_INVOICE_ACTION.REPLACE,
                            });
                            handleSubmit(onSubmitActionTT32)();
                          }}
                        >
                          <i className="bx bx-rotate-left font-size-18 text-primary" />
                          <span>Thay thế hóa đơn TT32</span>
                        </DropdownItem>{" "}
                        {/* <DropdownItem
                            style={{ position: "relative" }}
                            className="d-flex gap-1 align-items-center"
                            onClick={() => {
                              setDataConfirmAction({
                                mode: MODE_INVOICE_ACTION.ADJUST,
                              });
                              handleSubmit(onSubmitActionTT32)();
                            }}
                          >
                            <i className="bx bx-edit font-size-18 text-primary" />
                            <span>Điều chỉnh hóa đơn TT32</span>
                          </DropdownItem>{" "} */}
                      </div>
                    </DropdownMenu>
                  </ButtonDropdown>
                </Col>
                {/* )} */}
              </Row>
              {/* Detail Modal */}
              <DetailInvoice
                isEnterprise={true}
                dataConfirmAction={dataConfirmAction}
                isOpenModal={detailModal}
                btnShowFooter={btnShowFooter}
                toggleModal={toggleDetailModal}
                khhdonDefault={getValues("khhdon") && getValues("khhdon").value}
                mode={getValues("typeHD") && getValues("typeHD").mode}
                pageView={getValues("typeHD") && getValues("typeHD").value}
                invoiceSymbolList={invoiceSymbolList.items}
                setDataInvoiceTemp={setDataInvoiceTemp}
                isRoleAccountant={isRoleAccountant}
                isRoleStore={isRoleStore}
              />
            </CardBody>
          </Card>
        </div>
      </div>
    </React.Fragment>
  );
};

export default CreateInvoice;
